let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("idy9a")).then(() => parcelRequire('fz788'));